import { render, staticRenderFns } from "./BuoyCVOO1DashboardWidget.vue?vue&type=template&id=c5ef0ace&scoped=true"
import script from "./BuoyCVOO1DashboardWidget.vue?vue&type=script&lang=js"
export * from "./BuoyCVOO1DashboardWidget.vue?vue&type=script&lang=js"
import style0 from "./BuoyCVOO1DashboardWidget.vue?vue&type=style&index=0&id=c5ef0ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ef0ace",
  null
  
)

export default component.exports